<mat-dialog-content class="mat-typography">
  <section class="allocate-employee-dialog-wrapper">
    <h2 class="cmn-popup-title">
      {{
        releaseEmployee
          ? "Release Allocated Employee"
          : employeesAllocationData
            ? "Edit Allocated Employee"
            : "Allocate Employee"
      }}
    </h2>
    
    <button class="cmn-close" mat-dialog-close></button>

    <form [formGroup]="allocateForm" (ngSubmit)="onAllocateEmployee()">
      <div class="property-title">
        <p>
          Property : <span>{{ propertyData?.propertyName }}</span>
        </p>
      </div>
      <div class="allocate-employee-form-wrapper">
        <div class="form-wrapper">
          <label for="">Employee <span class="red">*</span></label>
          <mat-form-field appearance="fill">
            <mat-label>Select Employee</mat-label>
            <mat-select formControlName="employeeId">
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Search'"
                  [noEntriesFoundLabel]="'No data found'"
                  (input)="onSearchEmployee($event)"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let employee of employeesData"
                [value]="employee.id"
              >
                {{ employee?.firstName + " " + employee?.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="custom-error">
            <mat-error
              *ngIf="
                allocateForm.get('employeeId')?.touched &&
                allocateForm.get('employeeId')?.hasError('required')
              "
            >
              Employee is required.
            </mat-error>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Start Date <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker1"
              placeholder="Start Date"
              formControlName="startDate"
              (dateChange)="onStartDateChange($event)"
              [min]="today"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <div class="custom-error">
            <mat-error
              *ngIf="
                allocateForm.get('startDate')?.touched &&
                allocateForm.get('startDate')?.hasError('required')
              "
            >
              Start Date is required.
            </mat-error>
          </div>
        </div>

        <div *ngIf="releaseEmployee" class="form-wrapper">
          <label for="">End Date </label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker2"
              placeholder="End Date"
              formControlName="endDate"
              [min]="minEndDate"
              (dateChange)="onEndDateChange($event)"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="btn-wrapper">
        <button class="cmn-next-btn" type="submit" [disabled]="loading">
          <span *ngIf="!loading">{{ releaseEmployee ? 'Release':'Allocate'}} Employee</span>
          <span *ngIf="loading">Loading...</span>
        </button>
      </div>
    </form>
  </section>
</mat-dialog-content>
